/* eslint-disable no-console */
const name = `%c i18n `;
const style = `background: #ff00f2ff; color: #fff; border-radius: 15px; padding: 2px;`;

export const I18N_DEBUG_KEY = 'i18n-debug';
export const I18N_PSEUDO_WRAPPED_KEY = 'i18n-pseudo-wrapped';
export const I18N_KEY_OVERLAY_KEY = 'i18n-key-overlay';
export const I18N_DEV_PANEL_KEY = 'i18n-dev-panel';
export const I18N_CIMODE_NS_KEY = 'i18n-cimode-ns';

const getFlag = (key: string): boolean => localStorage.getItem(key) === 'true';

export const isI18nDebugActive = getFlag(I18N_DEBUG_KEY);
export const isI18nPseudoWrapped = getFlag(I18N_PSEUDO_WRAPPED_KEY);
export const isI18nKeyOverlayActive = getFlag(I18N_KEY_OVERLAY_KEY);
export const isI18nDevPanelActive = getFlag(I18N_DEV_PANEL_KEY);
// Default true; an explicit 'false' in localStorage opts out (debug-only knob).
export const isI18nCimodeNsAppended =
	localStorage.getItem(I18N_CIMODE_NS_KEY) !== 'false';

export const i18nDebugLog = (...args: Array<unknown>): void => {
	if (isI18nDebugActive) console.log(name, style, ...args);
};

export const i18nDebugWarn = (...args: Array<unknown>): void => {
	if (isI18nDebugActive) console.warn(name, style, ...args);
};

export const i18nDebugError = (...args: Array<unknown>): void => {
	if (isI18nDebugActive) console.error(name, style, ...args);
};
